module.exports = __webpack_public_path__ + "img/photo-film-music.00a0c240.svg";